import React, { useState, useEffect } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { FaHome, FaRobot, FaUsers, FaMoneyBill, FaSignOutAlt, FaUser, FaBars, FaTimes, FaHeart, FaMapMarker, FaLink, FaCity, FaListAlt, FaSearch } from 'react-icons/fa';
const AdminLayout = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [adminData, setAdminData] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('adminToken');
        const admin = localStorage.getItem('adminData');
        
        if (!token) {
            navigate('/admin/login');
        } else {
            setAdminData(JSON.parse(admin));
        }
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminData');
        navigate('/admin/login');
        toast.info('Logged out successfully');
    };

    const menuItems = [
        { path: '/admin/dashboard', icon: FaHome, label: 'Dashboard' },
            { path: '/admin/ai', icon: FaRobot, label: 'AI Admin' },        // ← ADD

        { path: '/admin/users', icon: FaUsers, label: 'Users' },
        { path: '/admin/payments', icon: FaMoneyBill, label: 'Payments' },
        { path: '/admin/matching', icon: FaLink, label: 'Matching' },
        { path: '/admin/states', icon: FaMapMarker, label: 'States' },
        { path: '/admin/cities', icon: FaCity, label: 'Cities' },
        { path: '/admin/caste-gotra', icon: FaListAlt, label: 'Castes & Gotras' }, // ✅ ADD THIS LINE
        { path: '/admin/profile', icon: FaUser, label: 'Profile' },
        { path: '/admin/search', icon: FaSearch, label: 'Search' }

    ];

    const isActive = (path) => location.pathname === path;

    return (
        <div className="min-h-screen bg-gray-100">
            {/* Mobile Sidebar Toggle */}
            <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="lg:hidden fixed top-4 left-4 z-50 p-2 bg-indigo-600 text-white rounded-lg"
            >
                {sidebarOpen ? <FaTimes /> : <FaBars />}
            </button>

            {/* Sidebar */}
            <div className={`fixed inset-y-0 left-0 z-40 w-64 bg-gradient-to-b from-red-800 to-blue-800 transform transition-transform duration-300 ease-in-out ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0`}>
                <div className="flex flex-col h-full">
                    {/* Logo */}
                    <div className="p-6 border-b border-white/20">
                        <div className="flex items-center justify-center space-x-2">
                            <FaHeart className="text-white text-2xl animate-pulse" />
                            <h1 className="text-white font-bold text-xl">Admin Panel</h1>
                        </div>
                        <p className="text-white/70 text-xs text-center mt-2">Bihebari Matrimony</p>
                    </div>

                    {/* Navigation */}
                    <nav className="flex-1 p-4 space-y-2">
                        {menuItems.map((item) => {
                            const Icon = item.icon;
                            return (
                                <Link
                                    key={item.path}
                                    to={item.path}
                                    onClick={() => setSidebarOpen(false)}
                                    className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-300 ${
                                        isActive(item.path)
                                            ? 'bg-white/20 text-white'
                                            : 'text-white/70 hover:bg-white/10 hover:text-white'
                                    }`}
                                >
                                    <Icon className="text-lg" />
                                    <span>{item.label}</span>
                                </Link>
                            );
                        })}
                    </nav>

                    {/* User Info & Logout */}
                    <div className="p-4 border-t border-white/20">
                        <div className="flex items-center space-x-3 mb-4">
                            <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                                <FaUser className="text-white" />
                            </div>
                            <div>
                                <p className="text-white font-medium">{adminData?.name || 'Admin'}</p>
                                <p className="text-white/60 text-xs">{adminData?.email}</p>
                            </div>
                        </div>
                        <button
                            onClick={handleLogout}
                            className="w-full flex items-center justify-center space-x-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
                        >
                            <FaSignOutAlt />
                            <span>Logout</span>
                        </button>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="lg:ml-64 min-h-screen">
                <main className="p-6">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default AdminLayout;